import { useCallback } from "react";
import AirplainIcon from '@material-ui/icons/Flight';
import Button from "@material-ui/core/Button";
import { planEditorVisibleState } from "../../store/PlanEditorVisibleState";
import { useRecoilState } from "recoil";

function PlanEditor() {
  const [planEditorVisible, setPlanEditorVisible] = useRecoilState(planEditorVisibleState);

  const clickHandler = useCallback(() => {
    setPlanEditorVisible(!planEditorVisible);
  },[planEditorVisible, setPlanEditorVisible]);

  return (
    <Button onClick={clickHandler}>
      <div className="header-item">
        <AirplainIcon color={planEditorVisible? 'primary': 'inherit'}/>
        <span className="header-item-label">Plan Editor</span>
      </div>
    </Button>
  );
}

export default PlanEditor;